import React from "react"
import * as hooks from "lib/hooks"
import { Typography } from "@mui/material"
import { ComponentTitleStyle } from "lib/styles/shared"

// eslint-disable-next-line @typescript-eslint/naming-convention, no-restricted-syntax
interface ComponentTitleProps {
	title: string
	align?: "left" | "center" | "right"
}

export function ComponentTitle({ title, align }: ComponentTitleProps) {
	const { theme } = hooks.UseTheme() // Access theme for styling

	return (
		<Typography
			variant="h5"
			align={align ?? "center"}
			sx={ComponentTitleStyle}
		>
			{title}
		</Typography>
	);
}
